import { atom } from "jotai";
import { ModalViewOptions } from "./Modal.d";

export const modalAtom = atom<ModalViewOptions | null>(null);
